import React from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import { UncomposedAddButton } from './addButton';
import logValueOnChange from '../commonActions/logValueOnChange';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
const AddSignatureButton = ({
  onChange,
  itemUserContentPath: _itemUserContentPath = null,
  user: {
    /* eslint-disable-next-line camelcase */
    user_id,
    firstName,
    lastName,
    email,
    employeeNumber
  },
  enabled,
  contentPath,
  groupedOptions: _groupedOptions = [],
  initialContent: _initialContent = null,
  optionsExclusionKey: _optionsExclusionKey = '',
  title,
  value: _value = {},
  path,
  parentContentPath,
  includeEmail: _includeEmail = false,
  includeEmployeeNumber: _includeEmployeeNumber = false
}) => {
  const wrappedChange = ({
    path: changePath,
    value: data
  }) => {
    const modifiedData = data;
    if (_itemUserContentPath) {
      modifiedData[_itemUserContentPath] = {
        /* eslint-disable-next-line camelcase */
        identifier: user_id,
        title: `${firstName} ${lastName}`
      };
      if (_includeEmail && email) {
        modifiedData[_itemUserContentPath].email = email;
      }
      if (_includeEmployeeNumber && employeeNumber) {
        modifiedData[_itemUserContentPath].employeeNumber = employeeNumber;
      }
    }
    onChange({
      path: changePath,
      value: modifiedData
    });
  };
  return /*#__PURE__*/React.createElement(UncomposedAddButton, {
    enabled: enabled,
    contentPath: contentPath,
    groupedOptions: _groupedOptions,
    initialContent: _initialContent,
    parentContentPath: parentContentPath,
    onChange: wrappedChange,
    optionsExclusionKey: _optionsExclusionKey,
    path: path,
    title: title,
    value: _value
  });
};
AddSignatureButton.propTypes = {
  itemUserContentPath: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  user: PropTypes.shape({
    user_id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    employeeNumber: PropTypes.string
  }).isRequired,
  value: PropTypes.shape({}),
  enabled: PropTypes.bool.isRequired,
  contentPath: PropTypes.string.isRequired,
  parentContentPath: PropTypes.string.isRequired,
  groupedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  initialContent: PropTypes.shape({}),
  optionsExclusionKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  includeEmail: PropTypes.bool,
  includeEmployeeNumber: PropTypes.bool
};
export { AddSignatureButton as UncomposedAddSignatureButton };
export default entityComposition(AddSignatureButton, [], {
  user: state => state.login.user,
  path: newPathSelector,
  onChange: logValueOnChange,
  enabled: enabledSelector,
  value: valueSelector,
  label: labelSelector
});